export const closeWebview = () => {
    if (window && window.venice && typeof window.venice.ppcClose === 'function') {
        window.venice.ppcClose();
    }
};
